import React, { Component } from 'react';
import { Button, CardBody, Card, Col, Row } from "reactstrap";
import axios from 'axios';
import { API_URL } from '../../config/Config';
import SaveLoader from "../../components/loader/SaveLoader";

export default class PassengerItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }

    async Deletpassenger(e) {
        this.setState({ loading: true })
        const access_token = localStorage.getItem('api_token');
        const options = {
            method: 'GET',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
            },
            url: API_URL + 'passenger-delete/' + e + '?api_token=' + access_token,
        };
        let response = await axios(options);
        console.log(response);
        if (response.status === 200) {
            window.location.reload();
        }
    }

    render() {
        const passenger = this.props.passenger;
        console.log(passenger);

        return (
            <Card>
                {this.state.loading === true && <SaveLoader type="spinningBubbles" color="#43b185" />}
                <CardBody>
                    <Row className='mt-3 md-5 rtl'>
                        <Col md='4' sm='12'>
                            <div className="passenger-result">
                                <span className="passenger-result-title">
                                    Name :
                                </span>
                                <span className="passenger-result-content">
                                    {passenger.firstname}
                                </span>
                            </div>
                        </Col>
                        <Col md='4' sm='12'>
                            <div className="passenger-result">
                                <span className="passenger-result-title">
                                    National Id / Passport No :
                                </span>
                                <span className="passenger-result-content">
                                    {passenger.country.un === "IRN" ? passenger.national_id : passenger.passport_no}
                                </span>
                            </div>
                        </Col>
                        <Col md='4' sm='12'>
                            <div className="passenger-result">
                                <span className="passenger-result-title">
                                    Brith Date :
                                </span>
                                <span className="passenger-result-content">
                                    {passenger.birthday}
                                </span>
                            </div>
                            <div className="edit-pasenger">
                                <Button onClick={this.Deletpassenger.bind(this, passenger.id)} ><i className="far fa-trash-alt"></i></Button>
                            </div>
                        </Col>
                    </Row>
                    <Row className='mt-3 md-5 rtl'>
                        <Col md='4' sm='12'>
                            <div className="passenger-result">
                                <span className="passenger-result-title">
                                    Family :
                                </span>
                                <span className="passenger-result-content">
                                    {passenger.lastname}
                                </span>
                            </div>
                        </Col>
                        <Col md='4' sm='12'>
                            <div className="passenger-result">
                                <span className="passenger-result-title">
                                    Nationality :
                                </span>
                                <span className="passenger-result-content">
                                    {passenger.country.name}
                                </span>
                            </div>
                        </Col>
                        <Col md='4' sm='12'>
                            <div className="passenger-result">
                                <span className="passenger-result-title">
                                    Passport Expiration :
                                </span>
                                <span className="passenger-result-content">
                                    {passenger.passport_expired}
                                </span>
                            </div>
                            <div className="edit-pasenger">
                                {/* <Button onClick={this.Editpassenger} ><i className="far fa-edit"></i></Button> */}
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/passenger/PassengerItem.jsx